import React, { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { trackEvent } from "../utils/gtm"

interface GTMPageTrackerProps {
  children: React.ReactNode
}

/**
 * A component that tracks page views using Google Tag Manager
 * Usage: Wrap your routes with this component
 */
const GTMPageTracker: React.FC<GTMPageTrackerProps> = ({ children }) => {
  const location = useLocation()

  useEffect(() => {
    // Track page view when location changes
    trackEvent({
      event: "page_view",
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    })
  }, [location])

  return <>{children}</>
}

export default GTMPageTracker
